import { actionTypes } from './actions';
import initialState from './initialState';

export default function ndfl2DetailsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('error', null);
    case actionTypes.REQUEST_SUCCESS: {
      return state.set('loading', false).set('data', state.get('data').concat([action.payload]));
    }
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    case actionTypes.NDFL_2_USE_ADD: {
      return state.set('used', action.ids);
    }
    case actionTypes.NDFL_2_USE_REMOVE:
      return state.withMutations((state) => {
        const { id, name } = action.origin;
        let index = state.get('used').findIndex((item) => item.id === id && item.name === name);
        state.get('used').splice(index, 1);
        index = state
          .get('data')
          .findIndex((item) => (item.incomes[0].origin = [id, name].join(':')));
        state.get('data').splice(index, 1);
      });
    default:
      return state;
  }
}
